import { Contacts, ContactUsForm } from "@/components/ContactUs";
import Section from "@/components/Section";
import BreadcrumbsNav from "@/components/UI-Kit/BreadcrumbsNav";
import { Container, Grid } from "@mui/material";

const ContactUs = () => {
  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 4, lg: 0 } }}>
        <BreadcrumbsNav />
      </Container>
      <Section
        pt={{ xs: 0, md: 4, lg: 12.5 }}
        pb={{ xs: 5, md: 8, lg: 20, xl: 30 }}
        heading="We’d love to hear from you."
        subTitle="Please fill out our contact form or contact us directly with any questions or concerns."
      >
        <Grid
          container
          columnSpacing={{ xs: 0, md: 3, lg: 10, xl: 20 }}
          rowSpacing={0}
          mt={{ xs: 4, md: 6, lg: 8.5 }}
        >
          <Grid item xs={12} md={6} mb={{ xs: 7.5, md: 0 }}>
            <ContactUsForm />
          </Grid>
          <Grid item xs={12} md={6}>
            <Contacts />
          </Grid>
        </Grid>
      </Section>
    </>
  );
};

export default ContactUs;
